import React from "react"

import { useAppSelector } from "redux/hooks"
import { selectStep } from "redux/features/dialog/dialogSlice"

export function withModalStep<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithModalStep = (props: GenericType) => {
    const step = useAppSelector((state) => selectStep(state))

    return <WrappedComponent {...props} step={step} />
  }

  return WithModalStep
}
